import { render, staticRenderFns } from "./quote-block.vue?vue&type=template&id=a58cac4a&scoped=true&"
import script from "./quote-block.vue?vue&type=script&lang=js&"
export * from "./quote-block.vue?vue&type=script&lang=js&"
import style0 from "./quote-block.vue?vue&type=style&index=0&id=a58cac4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58cac4a",
  null
  
)

export default component.exports